import axios from "axios";
import store from "../redux/store";
import { logoutAction } from "../redux/sessao/sessaoActions";
import { analytics } from "../firebase-config";

import { toast } from "react-toastify";

const api = axios.create({ timeout: 150000 });
let isHandlingAuthError = false;

api.interceptors.request.use(async (config) => {
  const state = store.getState();
  config.headers["X-User-Id"] = state.sessao.usuario?.id;
  config.headers["X-Tenant-Code"] = state.cfgGeral.tenantCode;

  const currentURL = window.location.href;

  const urlPartida = currentURL
    .split(".projete.app")[0]
    .replace("https://", "");

  // config.baseURL = `https://api.projete.app.br/${urlPartida.replace(
  //   "https://",
  //   ""
  // )}`;

  config.baseURL = "https://beta.projete.app.br/";
  if (urlPartida.includes("localhost")) {
    config.baseURL = "http://localhost:50003";
    // config.headers["X-Tenant-Code"] = 4233;
  }

  const token = state.sessao.tokenJWT;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },

  async (error) => {
    analytics.logEvent("api-exception", { description: error, fatal: true });

    const message = error?.response?.data;
    const status = error?.response?.status;

    if (message === "Usuário inexistente ou senha inválida") {
      return Promise.reject(new Error(message));
    }

    const isAuthError =
      message === "Token JWT invalido ou expirado!" || status === 403;

    if (isAuthError) {
      if (!isHandlingAuthError) {
        isHandlingAuthError = true;

        store.dispatch(logoutAction());
        toast("Seu login expirou. Por favor, faça login novamente", {
          position: "top-center",
          style: {
            background: "#ff4d4f",
            color: "#fff",
            fontWeight: "bold",
          },
        });
      }

      return Promise.resolve([]);
    }

    if (status == 401) {
      toast("Usuário ou senha inválidos", {
        position: "top-center",
        style: {
          background: "#ff4d4f",
          color: "#fff",
          fontWeight: "bold",
        },
      });
      return Promise.resolve([]);
    }

    return Promise.reject(error);
  }
);

export default api;
